import { render, staticRenderFns } from "./registrarGarantia.vue?vue&type=template&id=710b375f&scoped=true"
import script from "./registrarGarantia.vue?vue&type=script&lang=js"
export * from "./registrarGarantia.vue?vue&type=script&lang=js"
import style0 from "./registrarGarantia.vue?vue&type=style&index=0&id=710b375f&prod&scoped=true&lang=css"
import style1 from "./registrarGarantia.vue?vue&type=style&index=1&id=710b375f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710b375f",
  null
  
)

export default component.exports